import { LayoutDashboard, ArrowLeftRight, CalendarClock, PiggyBank, Landmark, Target, BarChart3, Settings, type LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  question: string;
  icon: LucideIcon;
}

/** 5 khu chính theo câu hỏi người dùng (PLAN.md mục 6) — cũng là 5 mục của thanh dưới trên điện thoại. */
export const ZONES: NavItem[] = [
  { to: '/v2', label: 'Tổng quan', question: 'Hôm nay thế nào?', icon: LayoutDashboard },
  { to: '/v2/du-kien', label: 'Dự kiến', question: 'Tháng này sẽ có gì?', icon: CalendarClock },
  { to: '/v2/giao-dich', label: 'Giao dịch', question: 'Tiền đã đi đâu?', icon: ArrowLeftRight },
  { to: '/v2/ngan-sach', label: 'Ngân sách', question: 'Tháng này còn bao nhiêu?', icon: PiggyBank },
  { to: '/v2/tai-san', label: 'Tài sản & Nợ', question: 'Tôi có gì, nợ gì?', icon: Landmark }
];

/** Menu phụ. */
export const SECONDARY: NavItem[] = [
  { to: '/v2/ke-hoach', label: 'Kế hoạch', question: 'Sắp tới ra sao?', icon: Target },
  { to: '/v2/bao-cao', label: 'Báo cáo', question: 'Số liệu theo kỳ', icon: BarChart3 },
  { to: '/v2/cai-dat', label: 'Cài đặt', question: 'Danh mục, sao lưu, tài khoản', icon: Settings }
];
